import { Component, Vue } from 'vue-property-decorator';
import { ListingsListDelegate } from '../../..//services/DataDelegate/ListingsDelegate/listings.list.delegate';

@Component
export default class ListingsHeader extends Vue {
   public title: string = 'ListingsHeader';
   public modalCreate: boolean = false;
   public listDelegate = new ListingsListDelegate();

   public formInline = {
      address: '',
      city: '',
      mls_number: '',
      agent: ''
   };
   public ruleInline = {
      address: [
         { type: 'string', trigger: 'blur' }
      ],
      city: [
         { type: 'string', trigger: 'blur' }
      ],
      mls_number: [
         { type: 'string', trigger: 'blur' }
      ],
      agent: [
         { type: 'string', trigger: 'blur' }
      ]
   };

   public async handleSearch() {
      this.$store.commit('listingStartFetching');
      await this.listDelegate.searchListings(this.formInline.address, this.formInline.city, this.formInline.mls_number, this.formInline.agent);
      this.$store.commit('updateListings');
      this.$store.commit('listingEndFetching');
   }

   public destroyed() {
      this.listDelegate.clearData();
   }
}
